import { render, staticRenderFns } from "./CampaignDetailIframe.vue?vue&type=template&id=aaaf80fc&scoped=true"
import script from "./CampaignDetailIframe.vue?vue&type=script&lang=js"
export * from "./CampaignDetailIframe.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/main.css?vue&type=style&index=0&id=aaaf80fc&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaaf80fc",
  null
  
)

export default component.exports